import React, { useEffect } from 'react';
import { Grid, Button, Select, MenuItem, InputLabel } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { LabelLine } from 'components/InputV2/components';
import { ButtonLoading, InputV2 } from 'components';
import { useStyles } from './style';
import createToast from 'components/Toast/Toast';
import Services from '../services';
import useCustomHook from './hooks';

const RequestCard = (props) => {
  const { onClose, wallet, guild, isGuild } = props;
  const classes = useStyles();
  const { control, handleSubmit, formState: { errors } } = useForm();
  const methods = useForm();
  const { operationCode, setOperationCode, loadBtn, setLoadBtn, type, setType } = useCustomHook();

  const navigate = useNavigate();
  const onSubmit = async (value) => {
    const values = methods.getValues();
    const regex = /(<([^>]+)>)/gi;
    if (regex.test(values.cardGroup)) {
      createToast('خطا', 'نمیتوانید در متن از تگ html استفاده کنید', 'danger');
      return;
    }

    let result;
    if (!String(values.username).trim() || !String(values.cardGroup).trim()) {
      createToast('خطا', 'مقدار وارد شده اشتباه است', 'danger');
      return;
    }

    setLoadBtn(true);
    if (type == 'branch') {
      // شعبه است
      result = await Services.getBranch({ businessName: String(values.username).trim() });
    } else {
      // تنخواه دار است
      result = await Services.getFunder({ username: String(values.username).trim() });
    }
    if (!result?.result || !result?.result?.length) {
      createToast('خطا', `${type === 'funder' ? 'کاربر یافت نشد' : 'شعبه یافت نشد'}`, 'danger');
      setLoadBtn(false);
      return;
    }

    try {
      if (type == 'branch') {
        const obj = {
          cardGroupCode: values?.cardGroup,
          currencyCode: null,
          payFeeByCustomer: operationCode,
          userId: result?.result[0]?.userId,
          walletCode: 'PODLAND_WALLET',
        };
        const s = await Services.requestCardIssuance(obj);
      } else {
        const objFunder = {
          cardGroupCode: values?.cardGroup,
          currencyCode: null,
          thingUserId: result?.result[0]?.userId,
          walletCode: 'PODLAND_WALLET',
        };
        const sFunder = await Services.requestCardIssuanceForThing(objFunder);
      }
      createToast('موفق', 'درخواست با موفقیت ثبت شد', 'success');

      onClose();
      setLoadBtn(false);
    } catch (error) {
      setLoadBtn(false);
    }
  };
  useEffect(() => {}, []);
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
          <Grid container spacing={4}>
            <Grid item xs={12}></Grid>

            <Grid item md={6} xs={6}>
              <InputLabel shrink className={classes.label}>
                <LabelLine label="پرداخت کارمزد توسط مشتری " />
              </InputLabel>
              <Select
                fullWidth
                value={operationCode}
                onChange={(e) => {
                  setOperationCode(e.target.value);
                }}
                variant="outlined"
                required={true}
                style={{ height: 38 }}
                className='pureSelect'
                name="payeValue"
              >
                <MenuItem value={true}>بله</MenuItem>
                <MenuItem value={false}>خیر</MenuItem>
              </Select>
            </Grid>

            <Grid item md={6} xs={6}>
              <InputLabel shrink className={classes.label}>
                <LabelLine label="نوع " />
              </InputLabel>
              <Select
                fullWidth
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                }}
                variant="outlined"
                required={true}
                style={{ height: 38 }}
                className='pureSelect'
                name="type"
              >
                <MenuItem value="funder">تنخواه دار</MenuItem>
                <MenuItem value="branch">شعبه</MenuItem>
              </Select>
            </Grid>
            <Grid item md={6} xs={6}>
              <InputV2
                fullWidth
                errors={methods.formState.errors}
                label={type == 'funder' ? 'نام کاربری' : 'نام شعبه'}
                name="username"
                register={methods.register}
                //dir="ltr"
                rules={['required']}
              />
            </Grid>
            <Grid item md={6} xs={6}>
              <InputV2
                fullWidth
                errors={methods.formState.errors}
                label="گروه کد کارت"
                name="cardGroup"
                register={methods.register}
                rules={['required']}
              />
            </Grid>

            <Grid  direction="row" container item xs={12} justifyContent='flex-end' className={classes.cardActions}>
              <ButtonLoading
                type="submit"
                color="primary"
                variant="contained"
                className={classes.button}
                loading={loadBtn}
                name="ثبت"
              />
              <Button
                variant="contained"
                onClick={() => onClose()}
                style={{ marginInlineStart: 10 }}
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </>
  );
};

export default RequestCard;
